import TabMenu from './TabMenu';
export default TabMenu;
